(() => {
  const initialize = (projectTags) => {
    const element = projectTags.element;
    const projectId = element.dataset.projectId;
    const list = element.querySelector('.project-tags__list');
    const arcGisApiLines = '//services1.arcgis.com/9meaaHE3uiba0zr8/arcgis/rest/services/Construction_Project_Lines_View/FeatureServer/0/query?';
    const arcGisApiMultipoints = '//services1.arcgis.com/9meaaHE3uiba0zr8/arcgis/rest/services/Construction_Project_Multipoints_View/FeatureServer/0/query?';
    const arcGisApiPolygons = '//services1.arcgis.com/9meaaHE3uiba0zr8/arcgis/rest/services/Construction_Project_Polygons_View/FeatureServer/0/query?';

    function createTags(project) {
      const { StartYear: year, ProjType: type, Department: department, Phase: phase, Status: status } = project[0].attributes;

      [year, type, department, phase, status].forEach((tag) => {
        const item = document.createElement('li');

        item.className = 'project-tags__item';
        item.textContent = tag;

        list.appendChild(item);
      });
    }

    function mergeProjects(projects) {
      return projects.map((apiEndpoint) => apiEndpoint.features).flat();
    }

    function getTags(id) {
      const params = new URLSearchParams({
        f: 'pjson',
        geometryType: 'esriGeometryEnvelope',
        outFields: 'StartYear,ProjType,Department,Phase,Status',
        resultRecordCount: 1,
        returnExceededLimitFeatures: true,
        returnGeometry: false,
        returnQueryGeometry: false,
        where: `ProjectID = '${id}'`,
      });

      const arcGisApiLinesJson = fetch(arcGisApiLines + params).then((response) => response.json());
      const arcGisApiMultipointsJson = fetch(arcGisApiMultipoints + params).then((response) => response.json());
      const arcGisApiPolygonsJson = fetch(arcGisApiPolygons + params).then((response) => response.json());

      return Promise.all([arcGisApiLinesJson, arcGisApiMultipointsJson, arcGisApiPolygonsJson])
        .then((projects) => mergeProjects(projects))
        .then((project) => (project.length > 0 ? createTags(project) : (element.remove(), false)))
        .catch((e) => console.error(e));
    }

    getTags(projectId);
  };

  const projectTags = stp.setup('project-tags');
  projectTags.map(initialize);
})();
